import { ReferenceMemberParameter } from '@modules/client';
import React, { FC } from 'react';
import isTypeOptional from '@modules/utilities/pageBuild/isTypeOptional';
import { Typography } from '@rbx/ui';
import useReferenceSummaryMemberTableStyles from './ReferenceSummaryMemberTable.styles';
import ReferenceMemberType from './ReferenceMemberType';

interface ReferenceMemberParameterItemProps {
  parameter: ReferenceMemberParameter;
  isLast?: boolean;
}

const ReferenceMemberParameterItem: FC<
  React.PropsWithChildren<ReferenceMemberParameterItemProps>
> = ({ parameter, isLast = false }) => {
  const {
    classes: { parameter: parameterClassname, parameterComma },
  } = useReferenceSummaryMemberTableStyles();

  return (
    <span className={parameterClassname}>
      <Typography variant='body1' component='span'>
        {parameter.name} :{' '}
      </Typography>
      <ReferenceMemberType parameter={parameter} isOptional={isTypeOptional(parameter.type)} />
      {!isLast && <span className={parameterComma}>,</span>}
    </span>
  );
};

export default ReferenceMemberParameterItem;
